var React = require('react');

function RatingStarHalfGreen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.5 12.75L3.50383 15.3766L4.45801 9.81332L0.41602 5.87336L6.00191 5.06168L8.5 0L10.9981 5.06168L16.584 5.87336L12.542 9.81332L13.4962 15.3766L8.5 12.75Z","fill":"#D7D7D7","key":0}),React.createElement("path",{"d":"M8.5 12.75L3.50382 15.3766L4.45801 9.81332L0.416016 5.87336L6.00191 5.06168L8.5 0V12.75Z","fill":"#4CAF50","key":1})]);
}

RatingStarHalfGreen.defaultProps = {"width":"100%","viewBox":"0 0 17 17","fill":"none"};

module.exports = RatingStarHalfGreen;

RatingStarHalfGreen.default = RatingStarHalfGreen;
